var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_966_3373)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.7881,
    y: 1.34961,
    width: 74.8472,
    height: 74.8472,
    rx: 16,
    transform: "rotate(12 26.7881 1.34961)",
    fill: "#077882",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 24.3037,
    width: 73.8472,
    height: 73.8472,
    rx: 15.5,
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 24.3037,
    width: 73.8472,
    height: 73.8472,
    rx: 15.5,
    stroke: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 75.0996C45.2833 75.0996 52 68.9429 52 61.3496C52 53.7563 45.2833 47.5996 37 47.5996C28.7167 47.5996 22 53.7563 22 61.3496C22 64.8563 23.4317 68.0546 25.7883 70.4829C26.5083 71.2279 27.0217 72.2163 26.765 73.2179C26.484 74.3132 25.958 75.3305 25.2267 76.1929C25.8119 76.2981 26.4054 76.3505 27 76.3496C29.1367 76.3496 31.1167 75.6796 32.7417 74.5379C34.0917 74.9046 35.5217 75.0996 37 75.0996Z",
    stroke: "#077882",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_966_3373"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 99.9996,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoChat);
export default __webpack_public_path__ + "static/media/noChat.03afc727d6a12ca6455ab6d9fbf2e1e2.svg";
export { ForwardRef as ReactComponent };